import { SFilter, SPaymentInfo } from './types';
import { DateConst } from '../../../../utils/date';

export const INITIAL_STATE = {
  SPaymentInfo: (): SPaymentInfo => ({
    totalDue: 0,
    credit: {
      amount: '',
      voucherId: [],
    },
    debit: {
      amount: '',
      voucherId: [],
    },
    paymentType: '',
    date: DateConst.todayUnix(),
    chequeNo: '',
    bankId: '',
    remark: '',
    payAmount: 0,
    purchaseDetails: [],
  }),

  SFilter: (): SFilter => ({
    orderBy: ORDER_BY['Due Amount'],
    orderType: ORDER_TYPE.Ascending,
  }),
};

const PAYMENT_TYPE = {
  Card: 'Card',
  Cash: 'Cash',
  UPI: 'UPI',
  Paytm: 'Paytm',
  Cheque: 'Cheque',
  'RTGS/NEFT': 'RTGS/NEFT',
};

export const Partial = 'Partial';

export const PURCHASE_PAYMENT_TYPE = {
  Default: { ...PAYMENT_TYPE, Split: 'Split' },
  WtSplit: { ...PAYMENT_TYPE },
  WPartial: {
    ...PAYMENT_TYPE,
    Split: 'Split',
    Partial: 'Partial',
    Pending: 'Pending',
  },
  WPending: { ...PAYMENT_TYPE, Split: 'Split', Pending: 'Pending' },
};

export const ORDER_BY = {
  'Due Amount': 'Due Amount',
  'Bill Date': 'Bill Date',
};

export const ORDER_TYPE = {
  Ascending: 'Ascending',
  Descending: 'Descending',
};
